// Bottom action bar while multi-select is active: count, size, ZIP download.
import React from 'react';
import { GALLERY, fmtBytes } from '../text.js';
import { DownloadIcon } from './icons.jsx';

export default function SelectBar({ bytes, count, onDone, onDownload, onSelectAll }) {
	return (
		<div className='selectbar' role='toolbar' aria-label='Auswahl'>
			<div className='selectbar__info'>
				<strong>{GALLERY.selected(count)}</strong>
				{count > 0 && <span className='selectbar__bytes'>{fmtBytes(bytes)}</span>}
			</div>
			<div className='selectbar__actions'>
				<button type='button' className='btn btn--ghost selectbar__btn' onClick={onSelectAll}>
					{GALLERY.selectAll}
				</button>
				<button type='button' className='btn btn--primary selectbar__btn' onClick={onDownload} disabled={count === 0}>
					<DownloadIcon size={15} />
					ZIP
				</button>
				<button type='button' className='btn selectbar__btn' onClick={onDone}>
					{GALLERY.selectDone}
				</button>
			</div>
		</div>
	);
}
